// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/views/CreateDataFactoryProject/assesment.css
// module id = 2511
// module chunks = 193